import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { CheckoutNotes } from "@components/organisms";
import { useCheckout } from "@sdk/react";
import isString from "lodash/isString";
import pickBy from "lodash/pickBy";
import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";

var CheckoutNotesSubpageWithRef = function CheckoutNotesSubpageWithRef(_ref, ref) {
  var changeSubmitProgress = _ref.changeSubmitProgress,
      onSuccess = _ref.onSuccess,
      noteFields = _ref.noteFields,
      props = _objectWithoutProperties(_ref, ["changeSubmitProgress", "onSuccess", "noteFields"]);

  var checkoutNotesFormId = "notes-form";
  var checkoutNotesFormRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      submitNotes: function submitNotes() {
        // TODO validate form
        checkoutNotesFormRef.current.dispatchEvent(new Event("submit", {
          cancelable: true
        }));
      }
    };
  });

  var _useCheckout = useCheckout(),
      checkout = _useCheckout.checkout,
      setNotes = _useCheckout.setNotes;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var notes = {
    deliveryNote: checkout === null || checkout === void 0 ? void 0 : checkout.deliveryNote,
    note: checkout === null || checkout === void 0 ? void 0 : checkout.note
  };

  var handleSetNotes =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(newNotes) {
      var filteredNotes, _ref3, dataError, submitErrors;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              filteredNotes = pickBy(newNotes, isString);

              if (!(Object.keys(filteredNotes).length === 0)) {
                _context.next = 4;
                break;
              }

              onSuccess();
              return _context.abrupt("return");

            case 4:
              changeSubmitProgress(true);
              _context.next = 7;
              return setNotes(filteredNotes);

            case 7:
              _ref3 = _context.sent;
              dataError = _ref3.dataError;
              submitErrors = dataError === null || dataError === void 0 ? void 0 : dataError.error;
              changeSubmitProgress(false);

              if (submitErrors) {
                setErrors(submitErrors);
              } else {
                setErrors([]);
                onSuccess();
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSetNotes(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return React.createElement(CheckoutNotes, _extends({}, props, {
    errors: errors,
    formId: checkoutNotesFormId,
    formRef: checkoutNotesFormRef,
    notes: notes,
    setNotes: handleSetNotes,
    noteFields: noteFields
  }));
};

var CheckoutNotesSubpage = forwardRef(CheckoutNotesSubpageWithRef);
export { CheckoutNotesSubpage };